import React from "react";
import cn from "clsx";
import { RenderElementProps } from "./FormElement";

export interface SectionHeaderProps extends RenderElementProps {}

export default function SectionHeader({
  id,
  label,
  className,
  display = true
}: SectionHeaderProps) {
  if (!label) {
    return null;
  }
  return (
    <header
      id={id}
      className={cn("section-header", className)}
      aria-hidden={!display}
    >
      <h3 className="section-header-title">{label}</h3>
    </header>
  );
}
